import { BorderButton } from "../buttons/BorderButton";
import Modal from "./Modal";

interface Props {
  visible: boolean;
  handleOk: () => void;
  handleCancel: () => void;
}

export function SaveChangesModal(props: Props) {
  const { visible, handleCancel, handleOk } = props;

  return (
    <Modal
      visible={visible}
      handleCancel={handleCancel}
      footer={
        <>
          <BorderButton type="submit" onClick={handleOk} className="px-8">
            Save
          </BorderButton>
          <BorderButton onClick={handleCancel} className="px-8">
            Discard Changes
          </BorderButton>
        </>
      }
      title="You have unsaved changes"
    >
      <p>Would you like to save the changes you made?</p>
    </Modal>
  );
}
